export default "__VITE_ASSET__D22Gks3W__"